import {ImageStyle} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';

export const IMAGE_CONTAINER_HEIGHT = 94;
export const IMAGE_CONTAINER_WIDTH_DESKTOP = 174;

export default ({image}: {image?: {width?: number; height?: number}}) =>
  useStyles(({theme, mediaOnly, platformOnly, addShadow}) => ({
    card: mediaOnly(DeviceSize.desktop, {flexDirection: 'row', alignItems: 'center'}, {flexDirection: 'column'}),
    imageWrapper: {
      ...mediaOnly(
        DeviceSize.desktop,
        {marginRight: 40, width: image?.width ?? IMAGE_CONTAINER_WIDTH_DESKTOP},
        {marginBottom: 22},
      ),
      overflow: 'hidden',
      justifyContent: 'center',
      backgroundColor: theme.color.white,
      borderRadius: 10,
      height: image?.height ?? IMAGE_CONTAINER_HEIGHT,
      ...platformOnly('web', {alignItems: 'center'}),
      ...addShadow({
        width: 0,
        height: 2,
        radius: 8,
        opacity: 0.08,
        color: theme.color.black,
        elevation: 10,
      }),
    },
    image: mediaOnly(
      DeviceSize.desktop,
      {
        width: image?.width ?? IMAGE_CONTAINER_WIDTH_DESKTOP,
        height: image?.height ?? IMAGE_CONTAINER_HEIGHT,
      },
      {width: '100%', height: image?.height ?? IMAGE_CONTAINER_HEIGHT},
    ) as ImageStyle,
    contentWrapper: {
      justifyContent: 'center',
    },
    contactsItem: {
      ...mediaOnly(DeviceSize.desktop, {marginTop: 10, marginBottom: 10}, {marginTop: 10, marginBottom: 10}),
      flexDirection: 'row',
      alignItems: 'center',
    },
    contactsItemIcon: {
      flexShrink: 0,
      flexGrow: 0,
      marginRight: 13,
      width: 24,
      height: 24,
      alignItems: 'center',
      color: theme.color.primaryColor,
    },
    contactsItemValue: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.h6Light),
      overflow: 'hidden',
    },
  }));
